var _style, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToothpaste02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#fff}.st1{fill:none;stroke:#231f20;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M635.8 466.9c17.8-5.1 37.6-1.3 52.5 11.6l853.1 745.1-1 1.1-390 390-1.2 1.1-746-852.2c-14.4-16.5-17.5-39.1-9.7-58.3 2.7-6.7 6.8-12.9 12.2-18.3l205.9-205.9c7-7 15.3-11.7 24.2-14.2z",
    id: "Layer_4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1626.6 1298l-402.9 403-74.6-85.2 1.2-1.1 390-390 1-1.1 85.3 74.4zM395.8 370.3h-.7v-.7l-1.3-1.3-100.4 100.5 108 108-8.3 128.3.5.2c2.7-6.7 6.8-12.9 12.2-18.3l205.9-205.9c6.9-6.9 15.3-11.7 24.1-14.2l-133.9 9.5-106.1-106.1zm-.7-151.3v150.6l.7.7h75.7V219h-76.4z",
    id: "Layer_5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1541.3 1223.6l85.3 74.5-402.9 402.9-74.6-85.2-745.9-852.2c-14.4-16.5-17.5-39.1-9.7-58.3 2.7-6.7 6.8-12.9 12.2-18.3l205.9-205.9c6.9-6.9 15.3-11.7 24.1-14.2 17.8-5.1 37.6-1.3 52.5 11.6l853.1 745.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1540.3 1224.7l-390 390"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M639.1 466.6l-3.3.3-133.9 9.4-106.1-106-.7-.7-1.2-1.3-100.5 100.5 108 108-8.3 128.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.8 370.3h-.7V219h76.4v151.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothpaste02);
export default __webpack_public_path__ + "static/media/toothpaste-02.4b72a26a598bafb8f8a96f0b67121080.svg";
export { ForwardRef as ReactComponent };